import React from 'react';

export const BadgePreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { text, variant, size, color } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px',
    display: 'inline-block'
  };
  
  const sizeStyles = {
    small: { padding: '2px 8px', fontSize: '11px' },
    medium: { padding: '4px 10px', fontSize: '12px' },
    large: { padding: '6px 12px', fontSize: '14px' }
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <span style={{
        display: 'inline-block',
        background: color || '#3B82F6',
        color: '#FFFFFF',
        borderRadius: '12px',
        fontWeight: '600',
        ...sizeStyles[size || 'medium']
      }}>
        {text || 'Badge'}
      </span>
    </div>
  );
};
